module.exports = __webpack_public_path__ + "img/0.84d53bae.png";